export const asApiConfig: string = '@api_config';